import AsyncBlockService from 'services/async-block-service';
import EF from 'ef/ef';
var Block = require('models/block');
var BlockCollection = require('collections/block_collection');


var utils = require('lib/utils');
var CourseSettingsService = require('services/course-settings-service');

import LoadService from 'services/load-service';
var LocaleService = require('services/locale-service');
var ForgeService = require('services/forge-service');

var ContentService = function() {
  if(ContentService.prototype._singleton) {
    return ContentService.prototype._singleton;
  }

  ContentService.prototype._singleton = this;

  this.files = {
    _groups: './content/groups.json',
    _modules: './content/modules.json',
    _moduleContent: './content/module-content.json'
  };

  this.initialize = function() {
    const split = CourseSettingsService.get('split_module');
    if(split) {
      this.files._modules = `./modules/${split}/content/module.json`;
      this.files._moduleContent = `./modules/${split}/content/module-content.json`;
    }
    return LoadService.load(this.files).then((data) => {
      Object.defineProperty(this, 'groups', { get: function() { return data._groups; } });
      Object.defineProperty(this, 'modules', { get: function() { return data._modules; } });
      Object.defineProperty(this, 'moduleContent', { get: function() { return data._moduleContent; } });
    });
  };

  this.applyPageContent = function(page) {
    let m, a, p;
    var linkedPage = page.get('link');
    if(linkedPage) {
      [m, a, p] = [linkedPage.module, linkedPage.activity, linkedPage.page];
    } else {
      [m, a, p] = [page.module.get('key'), page.activity.get('key'), page.get('key')];
    }
    return this.applyContentAndLocale(page, m + '.' + a + '.' + p).then(() => {
      this.addForgePathsToPage(page);
      return Promise.resolve(page);
    });
  };
  
  this.addForgePathsToContentRegion = function(regionName, region) {
    if(EF.forge_mode && region) {
      // Precaution for deeply nested region objects
      Object.entries(region).forEach(([key, value]) => {
        if(key === 'blocks')
          return this.addPaths(regionName, region);
       
        this.addForgePathsToContentRegion(regionName,value);   
      });
    }
  };

  this.addForgePathsToPage = function(page) {
    if(EF.forge_mode && page) {
      page.attributes.blocks.models.forEach(function(pageBlock,idx) {
        pageBlock.attributes.forge_path = 'blocks,'+idx;
        pageBlock.attributes.content_region = '#page-container';
        ForgeService.initContextMenus();
        ForgeService.traverseBlocks(pageBlock.attributes,['blocks',idx], '#page-container');
      });
    }
  };

  this.applyContentAndLocale = function(container, path) {
    return this.applyContent(container, path).then((containerParam) => {
      LocaleService.addDefaultResources(path);
      return Promise.resolve(containerParam);
    });
  };


  this.applyDirectPageContent = function(page, content) {
    return this.buildBlockCollection(content && content.blocks).then((blocks) => {
      if(content && content.blocks) {
        content.blocks = blocks;
      }
      page.set(content);
      this.reloadPageContentInPlace(page);
    });
  };

  this.reloadPageContentInPlace = function(page) {
    if(EF.forge_mode) {
      this.addForgePathsToPage(page);
      // reconstruct the page from controller to reattach events
      var PageView = require('views/page/page-view');
      const controller  = window.forge_data.controller;
      const className = window.forge_data.pageClassName;
      controller.view.dispose();
      controller.view = new PageView({
        region: 'main',
        model: page,
        className: className
      });
      controller.view.play();
      controller.view.subview('blocks');
    }
  };

  this.applyContent = function(container, path) {
    // Deep clone, so that the original source is not mutated
    //   This was causing some of the translations, to get translated twice and spit out error text
    var content = _.clone(utils.dotStringToObject(path, this.moduleContent), true);
    return this.buildBlockCollection(content && content.blocks).then((blocks) => {
      if(content && content.blocks) {
        content.blocks = blocks;
      }
      container.set(content);
      return Promise.resolve(container);
    });
  };

  this.buildBlockCollection = function(rawBlocks) {
    if(!rawBlocks) { return new Promise( resolve => resolve() ); }
    return AsyncBlockService.load(rawBlocks.map(b => b.type || b.get('type'))).then(() => {
      return Promise.resolve(
        rawBlocks instanceof Backbone.Collection ? rawBlocks : new BlockCollection(rawBlocks.map((block) => {
          if(typeof block === 'string' && this.moduleContent['base-blocks'] !== undefined) {
            block = this.moduleContent['base-blocks'][block];
          }
          if(this.blockAvailable(block)) {
            return new Block(block);
          }
        }).filter(b => b !== undefined))
      );
    });
  };

  this.blockAvailable = function(block) {
    let available = true;
    if(block.completed_modules_required) {
      available = block.completed_modules_required <= EF.modules.completedModuleCount();
    }
    if(available && block.certified !== undefined) {
      available = block.certified === Boolean(EF.enrollment.get('certified'));
    }
    if(available && block.fullSCORM !== undefined) {
      available = block.fullSCORM === Boolean(EF.config.get('fullSCORM'));
    }

    return available;
  };

  this.addPaths = (regionName, region) => {
    region.blocks.forEach(function(block, index) {
      block.forge_path = `blocks,${index}`;
      block.content_region = regionName;
      ForgeService.initContextMenus();
      ForgeService.traverseBlocks(block, ['blocks', index], regionName);   
     });
  };
};

module.exports = new ContentService();
